import React from 'react';
import classnames from 'classnames'
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { writeWarn } from '../../common/logger';
import PropTypes from 'prop-types'
import AmlRequestForm from './amlRequestForm';
import Message from '../../common/message';

import './aml.scss';

export const amlReportStatus = {
    notRequested: 'notRequested',
    inProgress: 'inProgress',
    available: 'available',
    failed: 'failed',
    offer: 'offer'
};

class AmlReportStatus extends React.Component {
    static propTypes = {
        data: PropTypes.any,
        dataHash: PropTypes.any,
        onNotRequested: PropTypes.func.isRequired,
        onInProgress: PropTypes.func.isRequired,
        asReport: PropTypes.bool,
        updateData: PropTypes.func,
        setAmlTreeValue: PropTypes.func,
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    handleButtonCLick = () => {
        if (this.props.user.authentication.profile.agentLanguage == "cs-CZ") {
            window.open('https://www.mcribis.cz/sluzby/aml/', '_blank');

        } else if (this.props.user.authentication.profile.agentLanguage == "sk-SK") {
            window.open('https://www.cribis.sk/sluzby/aml/', '_blank');
        }
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderContent(this.props.data)}</div>);
    }

    onClick = () => {
        if (this.props.asReport) {
            this.props.updateData();
        } else {
            this.props.onNotRequested();
        }
    }

    renderContent = (data) => {
        switch (data.reportStatus) {
            case amlReportStatus.notRequested:
                return (
                    <div className="columns is-centered">
                        <div className="column is-narrow has-text-centered">
                            <AmlRequestForm data={this.props.data} onClick={this.onClick} asReport={this.props.asReport} setAmlTreeValue={this.props.setAmlTreeValue} />
                        </div>
                    </div>
                )
            case amlReportStatus.inProgress:
                return (
                    <div className="columns is-centered">
                        <div className="column is-narrow has-text-centered">
                            <span style={{ fontWeight: 600, marginBottom: "1em", display: "flex" }}><Translate id="Report.Aml.InProgressNotice" /></span>
                            <br />
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div onClick={() => this.props.onInProgress()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                    <Translate id="Report.Aml.ReloadSection" />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            case amlReportStatus.available:
                return (
                    <>
                        {this.props.children}
                    </>
                )
            case amlReportStatus.failed:
                return <Message type='warning' message={<Translate id={"Report.Aml.FailNotice"} options={{ renderInnerHtml: true }} />} shadowed={true} />
            case amlReportStatus.offer:
                return (
                    <div style={{ textAlign: 'center', marginTop: "27px", marginBottom: "27px" }}>
                        <div style={{ marginLeft: "351px", marginRight: "351px" }}> <Translate id="Report.Aml.Offer" data={{ email: data.email }} options={{ renderInnerHtml: true }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: "27px" }}>
                            <div onClick={() => this.handleButtonCLick()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                <Translate id="Common.MoreInformation" />
                            </div>
                        </div>
                    </div>
                )
            default:
                writeWarn('Invalid aml report status: ' + data.reportStatus);
                return null;
        }
    }
}

export default connect(state => ({ user: state.userContext }))(AmlReportStatus);
